import { memo } from "react";
import ContactForm from "./ContactForm";

function ContactUs() {
  return (
    <main className="page-content contact-us-page p-4 pt-5 pt-md-5 m-0" aria-label="Contact us">
      <ContactForm />
    </main>
  );
}

ContactUs.displayName = "ContactUs";

export default memo(ContactUs);
